export default __webpack_public_path__ + "static/media/filterIcon.99f5de90.svg";